import { usePageTracking } from "@/hooks/usePageTracking";

export function PageTracker() {
  usePageTracking();
  return null;
}
